import React from 'react';

function SANGE() {

  return (
    <div className="pdf-page">
    <iframe
      src="pdf/SAUDI_ARABIAN_NATIONAL_GEOSPATIAL_ECOSYSTEM.pdf"
      title="PDF Document"
    />
  </div>
  );
}

export default SANGE;
